import { FormSection } from "Components/Shared/FormSection";
import { useGenderList } from "Hooks/Options/useGenderList";
import { usePartyTypeList } from "Hooks/Options/usePartyTypeList";
import { useCountryNameResolver } from "Translations/countryNames";
import { Resources, useResource } from "Translations/Resources";
import type { PartyDto } from "Infrastructure/Api/Api";
import { Stack } from "@mui/material";
import { DataRow } from "Components/Shared/DataRow/DataRow";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Party.Form.SelfEmployed;

type Props = {
  party: PartyDto;
};

export const SelfEmployedDataDisplay = ({ party }: Props) => {
  const { t } = useResource();
  const partyTypeList = usePartyTypeList({ onlyBusiness: false });
  const genders = useGenderList();
  const { getCountryName } = useCountryNameResolver();

  const partyTypeName = partyTypeList.find(
    ({ code }) => code === party.type,
  )?.name;
  const translatedGender = genders.find(
    ({ code }) => code === party.gender,
  )?.name;
  const nationality = getCountryName(party.nationality);

  return (
    <FormSection legend={t(COMPONENT_RESOURCES.Legend.Company)}>
      <Stack gap={2}>
        <DataRow label={t(COMPONENT_RESOURCES.Type)} value={partyTypeName} />
        <DataRow
          label={t(COMPONENT_RESOURCES.CompanyName)}
          value={party.companyName}
        />
        <DataRow
          label={t(COMPONENT_RESOURCES.FirstName)}
          value={party.firstName}
        />
        <DataRow
          label={t(COMPONENT_RESOURCES.LastName)}
          value={party.lastName}
        />
        <DataRow
          label={t(COMPONENT_RESOURCES.CompanyNumber)}
          value={party.companyNumber}
        />
        <DataRow
          label={t(COMPONENT_RESOURCES.TaxNumber)}
          value={party.taxNumber}
        />
        <DataRow
          label={t(COMPONENT_RESOURCES.PersonalNumber)}
          value={party.personalNumber}
        />
        <DataRow
          label={t(COMPONENT_RESOURCES.Gender)}
          value={translatedGender}
        />
        <DataRow
          label={t(COMPONENT_RESOURCES.BirthPlace)}
          value={party.birthPlace}
        />
        <DataRow
          label={t(Resources.Common.Nationality)}
          value={nationality || null}
        />
      </Stack>
    </FormSection>
  );
};
